export default "__VITE_ASSET__C1zEWFMC__ 100w";